import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type SsoAuthorizationUrlSerializer = {
  email: string;
  invitationCode: string,
  verificationCode: string,
  authorizationUrl: string,
};

export type PostSsoAuthorizationUrlPayloadType = (
  Pick<SsoAuthorizationUrlSerializer, 'email' | 'invitationCode' | 'verificationCode'>
);
export type PostSsoAuthorizationUrlResponseType = (
  Pick<SsoAuthorizationUrlSerializer, 'authorizationUrl'>
);

export const apiFetchSsoAuthorizationUrl = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostSsoAuthorizationUrlPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('public');
    const res = await client.post({
      url: urls.v1.ssoAuthorizationUrl(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
